import React, { useEffect, useRef, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { Flex, Skeleton } from 'antd';
import { withRouter } from "../../../../utils/services/with-router";
import { getProductList } from "../../actions/Product.action";
import { ProductListProps, ProductListFilterModel } from "../../models";
import ProductCard from "../../../../shared/components/productCard/ProductCard";
import ProductListHeader from "../../components/productListHeader/ProductListHeader";
import AdsBanner from "../../../../shared/components/adsBanner/AdsBanner";
import { EmptyMessage, getUserCities } from "../../../../shared";
import { useParams, useLocation } from 'react-router-dom';

const ProductList = ({ getProductList, getUserCities }: ProductListProps) => {
    const { subCategoryId } = useParams();
    const location = useLocation();
    const [searchText, setSearchText] = useState(location.state?.searchText || "");
    const [filterProps, setFilterProps] = useState<any>();
    const [products, setProducts] = useState<any[]>([]);
    const [citiesId, setCitiesId] = useState<any[]>([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const observerRef = useRef<IntersectionObserver | null>(null);
    const loadMoreRef = useRef(null);

    // Load products
    const getList = useCallback((pageNumber: number, isAppend = false) => {
        setLoading(true);
        const model: ProductListFilterModel = {
            fromIndex: ((pageNumber - 1) * 15 ).toString(),
            toIndex: (((pageNumber * 15))-1).toString(),
            fromPrice: filterProps?.fromPrice,
            toPrice: filterProps?.toPrice,
            searchText,
            subCategoryId,
        };

        getProductList(model)
            .then((data: any) => {
                const newProducts = data?.payload?.data || [];
                console.log(newProducts);
                setProducts(prev => isAppend ? [...prev, ...newProducts] : newProducts);
                setHasMore(newProducts.length === 14); // If less than 10, no more
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [getProductList, subCategoryId, filterProps, searchText]);

    // First load / reset on filter change
    useEffect(() => {
        setProducts([]);
        setPage(1);
        setHasMore(true);
        getList(1, false);
    }, [filterProps, searchText, getList]);

    // Load more on scroll
    useEffect(() => {
        console.log(hasMore)
        if (loading || !hasMore) return;

        if (observerRef.current) observerRef.current.disconnect();

        observerRef.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                setPage(prev => prev + 1);
            }
        });

        if (loadMoreRef.current) {
            observerRef.current.observe(loadMoreRef.current);
        }
    }, [loading, hasMore]);

    // Load page > 1 data
    useEffect(() => {
        if (page > 1 && hasMore) {
            getList(page, true);
        }
    }, [page, getList]);

    // Cities on mount
    useEffect(() => {
        getUserCities()
            .then((res: any) => {
                if (res?.payload?.data) {
                    setCitiesId(res.payload.data);
                }
            });
    }, [getUserCities]);

    return (
        <Flex vertical gap="small">
            <ProductListHeader
                citiesId={citiesId}
                onSearchHandle={setSearchText}
                onFilterApply={setFilterProps}
            />
            <Flex vertical gap="small" style={{marginTop:"130px"}}>
                <AdsBanner />

                {products.length === 0 && !loading && (
                    <EmptyMessage message="آگهی در حال حاضر موجود نیست !" />
                )}

                {products.map((item: any) => (
                    <ProductCard key={item.id} product={item} />
                ))}

                {loading && (
                    <Flex vertical>
                        <Skeleton active />
                        <Skeleton active />
                    </Flex>
                )}

                <div ref={loadMoreRef} style={{ height: 1 }} />
            </Flex>
        </Flex>
    );
};

export default connect(null, { getProductList, getUserCities })(withRouter(ProductList));
